export const TOUR_VERSION = "v1";
export const TOUR_STORAGE_KEY = `phonebook_tour_completed_${TOUR_VERSION}`;
export const TOUR_STEP_KEY = `phonebook_tour_step_${TOUR_VERSION}`;
export const TOUR_SESSION_SHOWN_KEY = `phonebook_tour_shown_session_${TOUR_VERSION}`;
export const TOUR_PENDING_FIRST_SESSION_KEY = `phonebook_tour_pending_first_${TOUR_VERSION}`;
export const TOUR_FIRST_TIME_DONE_EVENT = "phonebook:tour-first-time-done";
export const TOUR_OPEN_EVENT = "phonebook:tour-open";

export const TOUR_STEPS = [
  {
    id: "welcome",
    tag: "Start",
    title: "Welcome to  PhoneBookPlus",
    description: "Smart contacts, secure chat, and privacy you control.",
    bullets: [
      "Connect with family, friends & colleagues",
      "Share only what each group should see",
      "Chat one-on-one or in groups",
    ],
    image: "/tour/welcome.svg",
    accent: "from-[#8A6CFF] to-[#6C45FF]",
    glow: "rgba(108,69,255,0.35)",
    showMobileHint: false,
  },
  {
    id: "navigation",
    tag: "Menu",
    title: "Find Your Way Around",
    description: "Chat, Contact, Group, Profile & Notifications — all in one menu.",
    bullets: [
      "Chat — conversations",
      "Contact — invites & friends",
      "Group, Profile & alerts",
    ],
    image: "/tour/navigation.svg",
    accent: "from-[#7A5AF8] to-[#5D7BFF]",
    glow: "rgba(93,123,255,0.3)",
    showMobileHint: true,
    mobileHint: "Mobile: menu at the bottom.",
    desktopHint: "Desktop: sidebar on the left.",
  },
  {
    id: "chat",
    tag: "Chat",
    title: "Chat in Real Time",
    description: "Message anyone in your network instantly.",
    bullets: [
      "Text, voice, photos & files",
      "See who's online",
      "Get message alerts",
    ],
    image: "/tour/chat.svg",
    accent: "from-[#8A6CFF] to-[#6C45FF]",
    glow: "rgba(108,69,255,0.32)",
    showMobileHint: false,
  },
  {
    id: "contacts",
    tag: "Contacts",
    title: "Grow Your Network",
    description: "Invite people and manage your circle.",
    bullets: [
      "Search & send invites",
      "Accept friend requests",
      "Set Family, Friend, Work, Others",
    ],
    image: "/tour/contacts.svg",
    accent: "from-[#9B7BFF] to-[#7A5AF8]",
    glow: "rgba(122,90,248,0.3)",
    showMobileHint: false,
  },
  {
    id: "groups",
    tag: "Groups",
    title: "Group Conversations",
    description: "Stay connected with teams and families.",
    bullets: [
      "Create or join groups",
      "Group chat with everyone",
      "Manage members",
    ],
    image: "/tour/groups.svg",
    accent: "from-[#6C45FF] to-[#59C5FF]",
    glow: "rgba(89,197,255,0.28)",
    showMobileHint: false,
  },
  {
    id: "profile",
    tag: "Profile",
    title: "Build Your Identity",
    description: "A complete profile helps people recognize you.",
    bullets: [
      "Personal info, work & education",
      "Photo & voice name",
      "Keep details updated",
    ],
    image: "/tour/profile.svg",
    accent: "from-[#8A6CFF] to-[#6C45FF]",
    glow: "rgba(108,69,255,0.3)",
    showMobileHint: false,
  },
  {
    id: "permissions",
    tag: "Privacy",
    title: "You Control the Details",
    description: "Choose what Family, Friends, Work & Others can see.",
    bullets: [
      "Visibility per profile section",
      "Four privacy levels",
      "Change anytime in Settings",
    ],
    image: "/tour/permissions.svg",
    accent: "from-[#7A5AF8] to-[#6C45FF]",
    glow: "rgba(108,69,255,0.34)",
    showMobileHint: false,
  },
  {
    id: "finish",
    tag: "Done",
    title: "You're Ready to Go",
    description: "Replay this tour anytime from Profile → Settings.",
    bullets: [
      "Complete your profile",
      "Enable notifications",
      "Invite your first contact",
    ],
    image: "/tour/finish.svg",
    accent: "from-[#4CD68A] to-[#2BA866]",
    glow: "rgba(60,201,122,0.32)",
    showMobileHint: false,
  },
];
